import access from './@access'
import account from './@account';
import sidebar from './sidebar'
import common from './common';
import layout from './layout';
import prompt from './prompt'
import user from './@user'
import product from './@product'
import document from './@document'
import logistic from './@logistic'
import group from './@group'
import role from './@role'
import business from './@business'
import location from './@location'
import region from './@region'
import rate from './@rate'
import injectionProp from './@injectionProp'
import injectionField from './@injectionField'
import report from './@report'
import repository from './@repository'
import operation from './@operation'
import tax from './@tax'
import wallet from './@wallet'
import transaction from './@transaction'

export default {
  [`@access`]: access,
  [`@account`]: account,
  [`sidebar`]: sidebar,
  [`common`]: common,
  [`layout`]: layout,
  [`prompt`]: prompt,
  [`@user`]: user,
  [`@product`]: product,
  [`@document`]: document,
  [`@logistic`]: logistic,
  [`@group`]: group,
  [`@role`]: role,
  [`@business`]: business,
  [`@location`]: location,
  [`@region`]: region,
  [`@rate`]: rate,
  [`@injectionProp`]: injectionProp,
  [`@injectionField`]: injectionField,
  [`@report`]: report,
  [`@repository`]: repository,
  [`@operation`]: operation,
  [`@tax`]: tax,
  [`@wallet`]:wallet,
  [`@transaction`]: transaction

};